/**
 * Nav portion of admin gear for Enterprise Settings
 *
 * @prettier
 * @author Alexander Nagelberg
 * @since 23.5
 */
import React from 'react'
import { NavLink } from 'react-router-dom'
import SettingsNav from '../../settings/containers/SettingsNav'

const EnterpriseSettingsNav = () => (
  <ul className='usa-sidenav-sub_list'>
    <li>
      <NavLink to='/lgyhub/admin/enterprise-settings' activeClassName='usa-current' exact>
        General
      </NavLink>
    </li>
    <SettingsNav />
  </ul>
)

export default EnterpriseSettingsNav
